






















































import { defineComponent, computed } from '@vue/composition-api';

enum Color {
    Gray = 'gray',
    White = 'white',
    Green = 'green',
}

export default defineComponent({
    props: {
        color: {
            type: String as () => Color,
            default: Color.Green,
            validator: (value: string) => Object.values(Color).includes(value as Color),
        },
    },
    setup() {
        const colorSchemes = computed(() => ({
            [Color.Green]: {
                gradientStart: '#41A38E',
                gradientEnd: '#21BCA5',
                innerGradientStart: 'rgba(19, 181, 157, 0.62)',
                innerGradientEnd: '#13B59D',
                stroke: '#13B59D',
                conicGradient: `rgba(19, 181, 157, 1) 0deg,
                                rgba(19, 181, 157, 0) 72deg,
                                rgba(19, 181, 157, 0) 288deg,
                                rgba(19, 181, 157, 1) 360deg`,
            },
            [Color.Gray]: {
                gradientStart: '#41A38E',
                gradientEnd: '#21BCA5',
                innerGradientStart: 'rgba(31, 35, 72, 0.62)',
                innerGradientEnd: '#1F2348',
                stroke: 'rgba(31, 35, 72, 0.15)',
                conicGradient: `rgba(31, 35, 72, 1) 0deg,
                                rgba(31, 35, 72, 0) 72deg,
                                rgba(31, 35, 72, 0) 288deg,
                                rgba(31, 35, 72, 1) 360deg`,
            },
            [Color.White]: {
                gradientStart: '#6B7280',
                gradientEnd: '#4B5563',
                innerGradientStart: 'white',
                innerGradientEnd: 'rgba(255, 255, 255, 0.62)',
                stroke: 'white',
                conicGradient: `rgba(255, 255, 255, 1) 0deg,
                                rgba(255, 255, 255, 0) 72deg,
                                rgba(255, 255, 255, 0) 288deg,
                                rgba(255, 255, 255, 1) 360deg`,
            },
        }));

        return {
            colorSchemes,
        };
    },
});
